module.exports = __webpack_public_path__ + "static/4-7a18ebdb9bbf2e777a28ce135ad0f25f.jpg";